import type { Release } from '../releases.ts';

export default {
  version: '0.18.1',
  date: '2026-10-02',
  title: 'Live source fixes',
  summary: [
    'Fixed: live source addresses show the server’s real name behind a reverse proxy',
    'Fixed: SRT sources accept AES-128, 192 and 256 keys',
    'Fixed: refused streams are reported in the live worker’s log',
    'Fixed: New key is offered only while a source is stopped',
  ],
  features: [],
  fixes: [
    'Live sources show the server’s real name in their address instead of localhost when PRISM runs behind a reverse proxy',
    'SRT live sources accept any encryption key length the app uses (AES-128, 192 or 256) instead of only AES-128',
    'Streams refused because of a wrong passphrase or stream key are reported in the live worker’s log (System status → Logs) as they happen',
    'New key is only offered while a source is stopped: a started source keeps listening with the key it started with',
  ],
} satisfies Release;
